<script setup lang="ts">
import { Button } from '../ui/button';
import { X } from 'lucide-vue-next';
import { quitAppAction } from '@/actions/electron/QuitAppAction.ts';

const quitApp = async () => {
    await quitAppAction();
};
</script>

<template>
    <div class="flex h-8 w-screen items-center justify-end border-b dark:bg-zinc-950">
        <div class="draggable h-full w-full" />
        <div class="flex items-center">
            <!-- Quit button -->
            <Button
                variant="outline"
                size="icon"
                class="size-8 h-[33px] rounded-none rounded-tr border-0 border-b text-zinc-400 dark:text-zinc-600"
                @click="quitApp"
            >
                <X class="size-4" />
            </Button>
        </div>
    </div>
</template>
